import styled, { css } from 'styled-components';
export const Container = styled.div `
  font-style: normal;
  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;

  ${({ $appearance }) => $appearance === 'primary' &&
    css `
      color: var(--text-primary);
    `}

  ${({ $appearance }) => $appearance === 'secondary' &&
    css `
      color: var(--text-secondary);
    `}

  ${({ $size }) => $size === 'xsmall' &&
    css `
      font-size: var(--font-size-200);
    `}

  ${({ $size }) => $size === 'small' &&
    css `
      font-size: var(--font-size-300);
    `}

  ${({ $size }) => $size === 'base' &&
    css `
      font-size: var(--font-size-400);
    `}

  ${({ $bold }) => $bold &&
    css `
      font-weight: var(--font-weight-medium);
    `}

  ${({ $bold }) => !$bold &&
    css `
      font-weight: var(--font-weight-regular);
    `}


  ul,
  ol {
    padding-left: var(--space-500);

    display: grid;
    gap: var(--space-200);
  }

  ul {
    list-style: disc;

    ${({ $size }) => $size === 'small' &&
    css `
        padding-left: var(--space-400);
      `}
  }

  ol {
    list-style: decimal;
  }

  a,
  button {
    line-height: inherit;
    text-decoration: underline;
    text-decoration-skip-ink: none;
    text-underline-offset: 0.15em;

    &:hover {
      color: var(--text-primary);
    }
  }

  strong {
    font-weight: var(--font-weight-semibold);
  }

  dl {
    display: grid;
    gap: var(--space-300);

    dt {
      font-weight: var(--font-weight-semibold);
    }

    dd {
      margin-top: var(--space-100);
    }
  }
`;
